if (!customElements.get('new-product-details')) {
  customElements.define('new-product-details', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) {
        if (this.gallery) this.galleryObserver?.observe(this.gallery);
        this.updateGalleryProgress();
        return;
      }
      this.ready = true;
      this.gallery = this.querySelector('[data-gallery]');
      this.dialog = this.querySelector('dialog');
      this.select = this.querySelector('[data-variant]');
      this.select?.addEventListener('change', () => this.updateVariant(true));
      this.optionControls = this.querySelector('[data-option-controls]');
      if (this.optionControls && this.select) {
        this.optionControls.hidden = false;
        this.select.closest('.npd__variant-field').hidden = true;
        this.optionControls.addEventListener('change', event => {
          const input = event.target.closest('[data-option-input]');
          if (!input) return;
          const groups = [...this.optionControls.querySelectorAll('[data-option-position]')];
          const values = groups.map(group => group.querySelector('input:checked, select')?.value);
          const changedPosition = Number(input.closest('[data-option-position]').dataset.optionPosition);
          const variants = [...this.select.options];
          let match = variants.find(option => JSON.parse(option.dataset.options).every((value, index) => value === values[index]));
          if (!match) {
            const candidates = variants.filter(option => JSON.parse(option.dataset.options)[changedPosition] === input.value);
            match = candidates.find(option => option.dataset.available === 'true') || candidates[0];
          }
          if (match) { this.select.value = match.value; this.updateVariant(true); }
        });
      }
      this.galleryProgress = this.querySelector('[data-gallery-progress]');
      if (this.galleryProgress && this.gallery) {
        this.galleryProgress.hidden = false;
        this.galleryProgress.addEventListener('input', () => {
          const distance = this.gallery.scrollWidth - this.gallery.clientWidth;
          const direction = getComputedStyle(this.gallery).direction === 'rtl' ? -1 : 1;
          this.gallery.scrollTo({ left: direction * distance * Number(this.galleryProgress.value) / 1000, behavior: 'instant' });
        });
        this.galleryObserver = new ResizeObserver(() => this.updateGalleryProgress());
        this.galleryObserver.observe(this.gallery);
      }
      this.querySelectorAll('[data-zoom]').forEach(link => {
        link.addEventListener('click', event => {
          if (!this.dialog?.showModal) return;
          event.preventDefault();
          this.zoomTrigger = link;
          const image = this.querySelector('[data-zoom-image]');
          image.src = link.href;
          image.alt = link.querySelector('img').alt;
          this.dialog.showModal();
        });
      });
      this.querySelector('[data-close]')?.addEventListener('click', () => this.dialog.close());
      this.dialog?.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const bounds = this.dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.dialog.close();
      });
      this.dialog?.addEventListener('close', () => this.zoomTrigger?.focus());
      this.querySelector('form')?.addEventListener('submit', event => {
        if (this.select?.selectedOptions[0]?.dataset.available === 'false') event.preventDefault();
      });
      this.gallery?.addEventListener('scroll', () => {
        cancelAnimationFrame(this.scrollFrame);
        this.scrollFrame = requestAnimationFrame(() => this.updateGalleryProgress());
      }, { passive: true });
      this.updateVariant(false);
      this.updateGalleryProgress();
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.scrollFrame);
      this.galleryObserver?.disconnect();
    }
    updateGalleryProgress() {
      if (!this.galleryProgress || !this.gallery) return;
      const distance = this.gallery.scrollWidth - this.gallery.clientWidth;
      this.galleryProgress.value = distance > 0 ? Math.min(1000, Math.abs(this.gallery.scrollLeft) / distance * 1000) : 0;
      const size = this.gallery.scrollWidth > 0 ? this.gallery.clientWidth / this.gallery.scrollWidth * 100 : 100;
      this.galleryProgress.style.setProperty('--npd-progress-size', size + '%');
    }
    showMedia(id, movePage) {
      const media = [...this.querySelectorAll('[data-media-id]')].find(item => item.dataset.mediaId === id);
      if (!media) return;

      if (matchMedia('(max-width: 768px)').matches) {
        this.gallery.scrollTo({ left: this.gallery.scrollLeft + media.getBoundingClientRect().left - this.gallery.getBoundingClientRect().left, behavior: 'instant' });
      } else if (movePage) media.scrollIntoView({ block: 'start', behavior: 'instant' });
    }
    updateVariant(userInitiated) {
      const option = this.select?.selectedOptions[0];
      if (!option) return;
      this.querySelector('[data-price]').textContent = option.dataset.price;
      const compare = this.querySelector('[data-compare]');
      compare.textContent = option.dataset.compare;
      compare.hidden = !option.dataset.compare;
      const available = option.dataset.available === 'true';
      this.querySelector('[data-add]').disabled = !available;
      const label = this.querySelector('[data-add-label]');
      label.textContent = available ? label.dataset.availableLabel : label.dataset.soldLabel;
      const payment = this.querySelector('[data-payment]');
      if (payment) payment.hidden = !available;
      if (this.optionControls) {
        const values = JSON.parse(option.dataset.options);
        this.optionControls.querySelectorAll('[data-option-position]').forEach(group => {
          const value = values[Number(group.dataset.optionPosition)];
          group.querySelectorAll('[data-option-input]').forEach(input => {
            if (input.type === 'radio') input.checked = input.value === value;
            else input.value = value;
          });
          const selected = group.querySelector('[data-option-selected]');
          if (selected) selected.textContent = value;
        });
      }
      if (option.dataset.media) this.showMedia(option.dataset.media, userInitiated);
      if (userInitiated) {
        const url = new URL(location.href);
        url.searchParams.set('variant', option.value);
        history.replaceState({}, '', url);
      }
    }
  });
}
